(function($) {

    //---------------------
    // Set variables for this document
    //---------------------
    var menuOpened = false;
    var navHeight = $(".nav").outerHeight();
    var subHeight = $('.nav__sub_wrapper').is(':visible') ? $('.nav__sub_wrapper').outerHeight(true) : 0;
    var infoHeight = 0;
    var fullHeight = navHeight + subHeight;
    if ($(".navigation-info").length) {
        infoHeight = $(".navigation-info").height();
        fullHeight = fullHeight + infoHeight;
    }



    //---------------------
    // Set variables for css on load and resize
    //---------------------
    document.documentElement.style.setProperty('--info-height', `${infoHeight ? infoHeight : 0}px`);
    document.documentElement.style.setProperty('--menu-full-height', `${fullHeight}px`);
    document.documentElement.style.setProperty('--menu-sub-height', `${subHeight}px`);
    var w = $(window).width();
    window.addEventListener('resize', () => {
        if ($(window).width() == w) return;
        w = $(window).width();
        navHeight = $(".nav").outerHeight();
        subHeight = $('.nav__sub_wrapper').is(':visible') ? $('.nav__sub_wrapper').outerHeight(true) : 0;
        fullHeight = navHeight + subHeight;
        infoHeight = 0;
        if ($(".navigation-info").length) {
            infoHeight = $(".navigation-info").height();
            fullHeight = fullHeight + infoHeight;
        }
        document.documentElement.style.setProperty('--info-height', `${infoHeight ? infoHeight : 0}px`);
        document.documentElement.style.setProperty('--menu-full-height', `${fullHeight}px`);
        document.documentElement.style.setProperty('--menu-sub-height', `${subHeight}px`);
    });




    $('.nav_m__main_link-child').click(function (){
        $(this).next('.nav_m__side').addClass('nav_m__side-open');
    });
    $('.nav_m__side_back').click(function (){
        $(this).parent('.nav_m__side').removeClass('nav_m__side-open');
    });


    //---------------------
    // Set sub menu left offset if overflows document
    //---------------------
    function setNavOffset() {
        $('.navigation__items > .navigation__item').each(function() {
            var $this = $(this);
            var $linksWidth = $(this).children('.navigation__submenu').outerWidth();
            var $documentWidth = $(window).outerWidth();
            var $offset = $(this).offset().left;
            var left = ($documentWidth - $offset) - $linksWidth - 15;
            if ($linksWidth > $documentWidth - $offset) {
                $this.children('.navigation__submenu').css('left', left)
            } else {
                $this.children('.navigation__submenu').css('left', '')
            }
        });
    }

    //---------------------
    // Add white background and overlay when hover to navigation
    //---------------------
    let mouseInside = false;
    $('.nav__main_link-child').on("mouseenter", function (e) {
        mouseInside = true;
        $('.nav').addClass('nav-bg');
        setTimeout(() => {
            if (mouseInside) {
                $('body').addClass('nav-overlay');
                $(this).closest('.nav__main_menu').addClass('nav__sub_transition');
            }
        }, 200)
    })
    $('.nav__main_menu').on("mouseleave", function (e) {
        $('body').removeClass('nav-overlay');
        $('.nav').removeClass('nav-bg');
        $(this).removeClass('nav__sub_transition');
        mouseInside = false;
    })
    // $('.nav__right_menu_items').on("mouseenter", function (e) {
    //     $('body').addClass('nav-overlay');
    //     setTimeout(() => {
    //         $(this).addClass('nav__sub_transition');
    //     }, 200)
    // })
    // $('.nav__right_menu_items').on("mouseleave", function (e) {
    //     $('body').removeClass('nav-overlay');
    //     $(this).removeClass('nav__sub_transition');
    // })


    //---------------------
    // On scroll functions
    //---------------------
    let lastScroll = 0;
    $(window).on('scroll',function() {
        var scroll = $(window).scrollTop();

        if(scroll > fullHeight) {
            // $('body').css('padding-top', navHeight)
            $(".nav").addClass("scrolled");
            setTimeout(function() {
                $('.nav').addClass("nav--animate");
            }, 200);
        } else {
            $(".nav").removeClass("scrolled");
            $('.nav').removeClass("nav--animate");
            // $('body').css('padding-top', '')
        }
        if(lastScroll - scroll > 0 && scroll > fullHeight) {
            $(".nav").addClass("scrollUp ");
        } else if (lastScroll - scroll < 0) {
            $(".nav").removeClass("scrollUp");
        }
        if(scroll > infoHeight) {
            $('.nav').removeClass("nav--top");
            $(".nav__sidebar").addClass("nav__sidebar-scrolled");
        } else {
            $('.nav').addClass("nav--top");
            $(".nav__sidebar").removeClass("nav__sidebar-scrolled");
        }
        lastScroll = scroll;

        // navAnimationClasses();
    });




    // $('.nav_m__header_link').on('click', function(e){
    //     let id = $(this).data('nav-open-category');
    //     if (!$(this).hasClass('active')){
    //         e.preventDefault();
    //         $('.nav_m__header_link').removeClass('active');
    //         $(this).addClass('active');
    //         $('.nav_m__main').removeClass('nav_m__main-active');
    //         $("[data-nav-category=" + id + "]").addClass('nav_m__main-active');
    //     } else {
    //
    //     }
    // });


    function onTouchNav() {
        var isTouchDevice = 'ontouchstart' in document.documentElement;

        if (isTouchDevice) {
            var lastTouchedLink = null;
            $('.nav__main_link-child').each(function(){
                $(this).on('touchstart', function(e) {
                    var $this = $(this);
                    $('.nav').addClass('nav-bg');

                    // Pokud je kliknuto na jiný odkaz než ten poslední dotknutý
                    if (lastTouchedLink && !$this.is(lastTouchedLink)) {
                        lastTouchedLink.removeData('touched'); // Odstraníme 'data-touched' z předchozího odkazu
                        lastTouchedLink.parent().removeClass('active');
                    }


                    // Pokud odkaz nemá atribut 'data-touched', přidej ho a zruš defaultní chování odkazu
                    if (!$this.data('touched')) {
                        e.preventDefault(); // Zruší defaultní akci odkazu
                        $this.data('touched', true); // Nastaví, že byl dotyk zaznamenán
                        $this.parent().addClass('active');
                        $('body').addClass('nav-overlay');
                        lastTouchedLink = $this; // Uloží odkaz jako poslední dotknutý

                        // Přidání event listeneru na dokument
                        $(document).on('touchstart.outsideLink', function(event) {
                            // Pokud uživatel klikne mimo poslední dotknutý odkaz
                            if (!$(event.target).is(lastTouchedLink)) {
                                lastTouchedLink.removeData('touched'); // Odstraní data-touched
                                lastTouchedLink.parent().removeClass('active');
                                lastTouchedLink = null;
                                $('body').removeClass('nav-overlay');
                                $('.nav').removeClass('nav-bg');

                                // Odeber event listener, už není potřeba
                                $(document).off('touchstart.outsideLink');
                            }
                        });
                    }
                });

            })
        }
    }


    //---------------------
    // On load functions
    //---------------------
    $(window).on('load',function() {
        setNavOffset();
        onTouchNav();
        if ($(document).scrollTop() === 0 ) {
            $('.nav').addClass("nav--top");
        }
    });


    //---------------------
    // On resize functions
    //---------------------
    var windowWidth = $(window).width();
    window.addEventListener('resize', () => {
        if ($(window).width() == windowWidth) return;
        windowWidth = $(window).width();
        // navAnimationClasses();
        setNavOffset();
    });


})(jQuery);